module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.9006/js/img/ServiceHub_Icon.svg"